// set local as default env (ng serve / ng build)
// prod: (ng serve --prod / ng build --prod) or (ng serve -c=production / ng build -c=production)
// dev: (ng serve -c=dev / ng build -c=dev)
// -c == --configuration
import { EnvironmentModel } from "./environment-model";

export const environment: EnvironmentModel = {
  production: false,
};
/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import "zone.js/plugins/zone-error"; // Included with Angular CLI.
